// test792
(792 && 0);
